// extracted by css-extract-rspack-plugin
export default {"SavedEntityPickerRoot":"oozcU","CollectionsContainer":"rQ8QV","BackButton":"yZsYu"};